import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../../constants/columnWidths";
import { accountTagsCell } from "../../../helpers/accountTagsCell";
import { inlineDueDateCell } from "../../../helpers/cellRenderers";
import {
  accountCell,
  brandCell,
  complexityCell,
  designTypeCell,
  nameCell,
} from "../../../helpers/commonCells";

// Designer Assigned to Me - Being Revised Section Configuration
// Columns: Name, Account, Due, Level, Brand, Design Type, Tags
export const designerAssignedToMeBeingRevisedTableConfig: TableConfig<GetRequestsListItem> =
  {
    columns: [
      {
        accessor: "name",
        cellRenderer: nameCell,
        header: "Name",
        key: "name",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.name,
      },
      {
        accessor: "account",
        cellRenderer: accountCell,
        header: "Account",
        key: "account",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.account,
      },
      {
        accessor: "dueDate",
        cellRenderer: inlineDueDateCell,
        header: "Due",
        key: "dueDate",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.dueDate,
      },
      {
        accessor: "complexity",
        cellRenderer: complexityCell,
        header: "Level",
        key: "complexity",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.complexity,
      },
      {
        accessor: "brand",
        cellRenderer: brandCell,
        header: "Brand",
        key: "brand",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.brand,
      },
      {
        accessor: "designType",
        cellRenderer: designTypeCell,
        header: "Design Type",
        key: "designType",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
      },
      {
        accessor: "account",
        cellRenderer: accountTagsCell,
        header: "Tags",
        key: "accountTags",
        sortable: false,
        width: 150,
      },
    ],
    defaultSort: {
      column: "dueDate",
      direction: "asc",
    },
    getRowClassName: whitelabelRowClassName,
    id: "designer-assigned-to-me-being-revised",
  };
